/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hero_Headline_ItalicInputs */

const et_hero_headline_italic = /** @type {(inputs: Hero_Headline_ItalicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Garanteeritud`)
};

const en_hero_headline_italic = /** @type {(inputs: Hero_Headline_ItalicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guaranteed`)
};

/**
* | output |
* | --- |
* | "Guaranteed" |
*
* @param {Hero_Headline_ItalicInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const hero_headline_italic = /** @type {((inputs?: Hero_Headline_ItalicInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hero_Headline_ItalicInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_hero_headline_italic(inputs)
	return en_hero_headline_italic(inputs)
});